import { falseIntersect, containsTransformControlsGizmo, tieBreakCondition, isHighestRenderOrder, getUserDataFromIntersections, isClosestToCamera, containsScaleMarker, intersectionsIncludeFalseDepthTestEntity, } from '../r3f-components/utils/general';
export const isHighestPointerPriority = (id, rayintersects, siblings, renderOrder, is3dMode, isScreenRelativeMode, depthTest = true) => {
    if (falseIntersect(id, rayintersects)) {
        return false;
    }
    if (is3dMode && !isScreenRelativeMode) {
        // If the transform controls gizmo is in the intersections array then it takes priority
        if (containsTransformControlsGizmo(rayintersects)) {
            return false;
        }
        // Two entities have the same distance ( and it's closest to camera ) then tie break
        // If one of the entities has depthTest false, then it wins over the other entity even if it's not closest to the camera, so we need to check renderorder
        if (tieBreakCondition(rayintersects, siblings) || intersectionsIncludeFalseDepthTestEntity(rayintersects, siblings)) {
            // Highest render order wins, so return if lower
            if (!isHighestRenderOrder({ userDataArray: getUserDataFromIntersections(rayintersects), renderOrder, sceneChildrenIds: siblings })) {
                return false;
            }
        }
        else {
            // If no tie break, closest to camera wins, so return if not closest
            if (!isClosestToCamera(getUserDataFromIntersections(rayintersects), renderOrder, siblings)) {
                return false;
            }
        }
    }
    else {
        // 2D or SR mode
        if (containsScaleMarker(rayintersects)) {
            return false;
        }
        if (!isHighestRenderOrder({ userDataArray: getUserDataFromIntersections(rayintersects), renderOrder, sceneChildrenIds: siblings })) {
            return false;
        }
    }
    return true;
};
// export const getEntityRenderOrder = (entity: ISpatialComponentUnion) => {
// 	return entity.renderOrder * 100;
// }
export const getEntityRenderOrder = (entity) => {
    if (typeof entity?.renderOrder !== 'number')
        return entity?.renderOrder;
    let renderOrder = entity.renderOrder * 100;
    if (entity.depthTest === false)
        renderOrder *= 100; // Entities with depthTest false are on top of those with depthTest true - click events need to reflect this
    return renderOrder;
};
